import styled from "styled-components";

// TEXT

// STYLES
export const Grow = styled.div`
  flex-grow: 1;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
